export class AppFeature {
    appFeatureId: number;
    appFeatureName: string;
}
